import { Link } from "react-router-dom";
import { Phone, MapPin, Clock, Instagram, Mail } from "lucide-react";
import { useSettings, telHref } from "@/context/SettingsContext";

export default function Footer() {
  const { settings } = useSettings();
  return (
    <footer className="bg-ink text-bone/80 mt-24">
      <div className="container-x py-20 grid md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="font-serif text-3xl text-bone">Giovanna Matino</div>
          <div className="eyebrow mt-2 text-gold">Architetto e Interior Designer</div>
          <p className="mt-6 max-w-md text-sm leading-relaxed text-bone/70" data-testid="footer-short-text">
            {settings.footer_short}
          </p>
          <div className="mt-6 flex gap-4 items-center">
            <a
              href={settings.instagram_url}
              target="_blank"
              rel="noreferrer"
              aria-label="Instagram"
              className="hover:text-gold transition-colors"
              data-testid="footer-instagram"
            >
              <Instagram size={18} />
            </a>
            <a href={`mailto:${settings.email}`} aria-label="Email" className="hover:text-gold transition-colors" data-testid="footer-email">
              <Mail size={18} />
            </a>
          </div>
        </div>

        <div>
          <div className="eyebrow text-bone/60 mb-5">Contatti</div>
          <ul className="space-y-4 text-sm text-bone/80">
            <li className="flex gap-3"><MapPin size={16} className="mt-1 text-gold shrink-0" /><span>{settings.address_line1}<br/>{settings.address_line2}</span></li>
            <li className="flex gap-3"><Phone size={16} className="mt-1 text-gold shrink-0" /><a href={telHref(settings.phone)} className="hover:text-gold" data-testid="footer-phone">{settings.phone}</a></li>
            <li className="flex gap-3"><Mail size={16} className="mt-1 text-gold shrink-0" /><a href={`mailto:${settings.email}`} className="hover:text-gold break-all">{settings.email}</a></li>
            <li className="flex gap-3"><Clock size={16} className="mt-1 text-gold shrink-0" /><span>{settings.opening_hours}</span></li>
          </ul>
        </div>

        <div>
          <div className="eyebrow text-bone/60 mb-5">Navigazione</div>
          <ul className="space-y-3 text-sm">
            {[
              ["/chi-sono","Chi Sono"],["/servizi","Servizi"],
              ["/portfolio","Portfolio"],["/blog","Diario"],
              ...(settings.shop_visible !== false ? [["/shop-the-project","Shop the Project"]] : []),
              ...(settings.library_visible !== false ? [["/library","Library"]] : []),
              ["/prenota","Prenota Consulenza"],
              ["/contatti","Contatti"],
            ].map(([to,l]) => (
              <li key={to}><Link to={to} className="hover:text-gold transition-colors">{l}</Link></li>
            ))}
          </ul>
        </div>
      </div>
      <div className="border-t border-bone/10">
        <div className="container-x py-6 flex flex-col md:flex-row justify-between gap-3 text-xs text-bone/50">
          <div data-testid="footer-legal-line">© {new Date().getFullYear()} Giovanna Matino · Architetto e Interior Designer · P.IVA {settings.piva}</div>
          <div className="flex gap-4 flex-wrap">
            <Link to="/privacy" className="hover:text-gold" data-testid="footer-privacy">Privacy Policy</Link>
            <Link to="/cookie" className="hover:text-gold" data-testid="footer-cookie">Cookie Policy</Link>
            <Link to="/termini" className="hover:text-gold" data-testid="footer-termini">Termini</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
